import React from "react";
import LegalLayout from "../../components/layout/LegalLayout";

const PrivacyPage: React.FC = () => (
  <LegalLayout>
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-lg p-8">
        <h1 className="text-3xl font-bold text-blue-700 mb-6">TyreLink.app Policies</h1>
        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">1. Privacy Policy</h2>
        <p className="text-gray-700 mb-4">
          TyreLink App (Pty) Ltd respects your privacy and complies with the Protection of Personal Information Act (POPIA).<br />
          We collect the following information: Name, Contact details, Vehicle details (make, model, year, tyre size), and Location.<br />
          We use your information only for the following purposes:
        </p>
        <ul className="list-disc pl-8 text-gray-700 mb-4">
          <li>To connect you with local tyre shops.</li>
          <li>To match tyres to your vehicle.</li>
          <li>To send reminders or marketing communications (if opted in).</li>
        </ul>
        <p className="text-gray-700 mb-4">
          We do not sell, rent, or share your personal information with tyre shops or third parties.<br />
          You may request access, correction, or deletion of your personal information at any time by contacting <a href="mailto:support@tyrelink.app" className="text-blue-600 hover:underline">support@tyrelink.app</a>.<br />
          You may withdraw your consent for marketing at any time by following the opt-out instructions in our communications.
        </p>
        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">2. Data Protection and Security Policy</h2>
        <p className="text-gray-700 mb-4">
          TyreLink uses industry-standard security measures to protect your data, including encryption and secure servers.<br />
          Access to personal data is restricted to authorized staff only.<br />
          We retain personal information only as long as necessary for the purposes stated in the Privacy Policy.<br />
          If a data breach occurs, we will notify affected users and the Information Regulator of South Africa where required by law.
        </p>
        <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-2">3. Acceptable Use Policy</h2>
        <p className="text-gray-700 mb-4">
          You must use TyreLink.app lawfully and responsibly.
        </p>
        <p className="text-gray-500 mt-8 text-sm">
          Last updated: September 2025
        </p>
      </div>
    </div>
  </LegalLayout>
);

export default PrivacyPage;